// login_new.js

import React, { memo, useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import '../../styles/login_new.scss';
import { Loading } from '@components';
import AppHeader from '../../container/appHeader';
import classnames from 'classnames';
import Logo from '@components/logo/index';
import { loginAction } from '../../flux/action/loginAction';
import { isValidLogin } from '../../utils/common';
import { LOGIN_TYPE } from '../../utils/newLoginConfig';
import AppFooter from '../../container/appFooter';
const { Button } = require('appkit-react');

const mapStateToProps = (state) => {
  const { login } = state;
  return {
    userInfo: login?.userInfo,
    isLogin: login?.isLogin,
  };
};

const mapDispatchToProps = (dispatch) => ({
  doLogin: (type) => loginAction.login(type),
  getLogin: (params) => dispatch(loginAction.getLogin(params)),
  getUserInfoFromToken: () => dispatch(loginAction.getUserInfoFromToken()),
});

function Login_new(props) {
  const { doLogin, getLogin, getUserInfoFromToken, userInfo, isLogin } = props;
  const history = useHistory();
  const [isloading, setIsloading] = useState(false);

  const isProcessingOAuth = useRef(false);

  // Check for code in URL
  const urlParams = new URLSearchParams(window.location.search);
  const hasCode = urlParams.has('code');
  const code = urlParams.get('code');

  // Handle OAuth callback
  useEffect(() => {
    const handleOAuthCallback = async () => {
      // Only process if we have code, not logged in, and not already processing
      if (hasCode && code && !isLogin && !isProcessingOAuth.current) {
        isProcessingOAuth.current = true;
        setIsloading(true);

        try {
          // Step 1: Exchange code for token
          const token = await getLogin(window.location.search);

          if (token) {
            // Step 2: Get user info
            await getUserInfoFromToken();
          } else {
            console.error('No token received!');
            throw new Error('No token received');
          }

          // Clean URL (remove code from URL)
          window.history.replaceState({}, document.title, '/login');
        } catch (error) {
          console.error('=== OAuth Failed ===', error);
          isProcessingOAuth.current = false;
          setIsloading(false);

          // Clean URL even on error
          window.history.replaceState({}, document.title, '/login');
        }
      }
    };

    handleOAuthCallback();
  }, [hasCode, code, isLogin, getLogin, getUserInfoFromToken]);

  // Handle login button click
  const redirectToIdam = (type) => {
    // Already logged in?
    if (isValidLogin() && userInfo && userInfo.uid) {
      history.replace('/');
      return;
    }

    setIsloading(true);

    // Trigger SSO redirect
    doLogin(type);
  };

  const getRoleControl = (userInfo = {}) => {
    switch (userInfo.role) {
      case 'admin':
        return 'role-admin';
      case 'internal':
        return 'role-internal';
      case 'client':
        return 'role-client';
      default:
        return 'role-client';
    }
  };

  // Show loading if processing OAuth or button clicked
  const showLoading = isloading || (hasCode && !isLogin);

  return (
    <div
      className={classnames(
        { 'app-container': true, 'app-filter': showLoading },
        getRoleControl(userInfo),
      )}
    >
      <div style={{ display: 'inline-grid', position: 'fixed' }}>
        <Logo />
      </div>
      <AppHeader />
      <div className="login-page-wrapper">
        {showLoading ? (
          <Loading tip="Logging in..." isLoading={true} />
        ) : (
          <div className="login-page-content">
            <div className="title">M&A Gateway</div>
            <div className="text">
              Welcome to M&A Gateway. <br />
              Please select an option below to sign in.
            </div>
            <div className="button-column">
              <Button
                className="btn-wrapper"
                size="xl"
                onClick={() => redirectToIdam(LOGIN_TYPE.IAM)}
              >
                Client User
              </Button>
              <Button
                className="btn-wrapper"
                size="xl"
                kind="secondary"
                onClick={() => redirectToIdam(LOGIN_TYPE.IDENTITY)}
              >
                PwC User
              </Button>
            </div>
          </div>
        )}
      </div>
      <AppFooter />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(memo(Login_new));
